import { setUpModernPage } from 'js/simple_layout/set_up_modern_page';
setUpModernPage();

import SingleClaimPage from 'js/claims/SingleClaimPage';
import registerForRails from 'js/utils/registerForRails';

registerForRails({
  SingleClaimPage,
});
